// 🔧 sponsor_level_defaults.js
// ✅ Purpose: Provides default Sponsor Level templates for the Sponsor Engine
// ✅ Features:
// - Industry-aware sponsor level generation
// - No Firestore access
// - Pure reusable template data
// - Future-ready for unlimited industries
// - Fully block-commented for clarity and future devs

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

/**
 * Builds sponsor level defaults for the selected industry.
 */
export const buildSponsorLevels = ({
  industryTemplate,
} = {}) => {
  return getPowerUpProfile(industryTemplate).sponsorLevels.map(
    (name, index) => createLevel(index + 1, name)
  );
};

/**
 * Creates a normalized sponsor level object.
 */
const createLevel = (
  displayOrder,
  name
) => ({
  id: displayOrder,
  name,
  description: "",
  displayOrder,
  demoSeed: true,
});
